export function determineCurrentSearchResult()
{
	dataholder.currentSearchResultString = '';
	const holder = $('.searchResultStringHolder');
	if( holder.length > 0 )
	{
		let string = $(holder).attr('data-ids');
		if(string !== '')
		{
			string = string.substr(0, string.length-1);
			dataholder.currentSearchResultString = string;
		}
	}
}

export function triggePrintPagePost(resultstring )
{
	const mapForm = document.createElement("form");
	mapForm.id = 'searchPrintPageForm';
	mapForm.target = "_blank";
	mapForm.method = "POST";
	mapForm.action = siteUrl+'/print-search/';

	const mapInput = document.createElement("input");
	mapInput.type = "hidden";
	mapInput.name = "printIds";
	mapInput.value = resultstring;

	mapForm.appendChild(mapInput);
	document.body.appendChild(mapForm);
	mapForm.submit();
}
